import { render, staticRenderFns } from "./addExpenseCategoryComponent.vue?vue&type=template&id=2fcdd267&"
import script from "./addExpenseCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./addExpenseCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports